import { Modal, Typography, Button } from '@frontend/design_system'
import {
  REQUEST_MODAL_DESCRIPTION,
  REQUEST_MODAL_SEND_EMAIL,
  REQUEST_MODAL_SUCCESS_NOTIFICATION,
  REQUEST_MODAL_TITLE,
} from 'texts/approval'
import styles from './styles.module.scss'
import { CANCEL, CONFIRM } from 'texts/uiTexts'
import { useApiRequest } from 'hooks/useApiRequest'
import { profileApi } from 'api'
import { useDispatch } from 'react-redux'
import { setNotificationMessage } from 'redux/notifications/slice'
import { setAccountStatus, setPageStatus } from 'redux/login/slice'
import { UserSection } from 'api/profile/types'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { useCompanyInfo } from 'ui/hooks/useCompanyInfo'
import { DocumentType } from 'api/documents/types'

interface IRequestModalProps {
  onClose: (e?: MouseEvent) => void
  companyId: string
  section: UserSection
  documentType?: keyof typeof DocumentType
}

export const RequestModal = ({
  onClose,
  companyId,
  section,
  documentType,
}: IRequestModalProps) => {
  const dispatch = useDispatch()

  const { getCompanyInfo } = useCompanyInfo(true)

  const { apiRequest: requestCompany, loading } = useApiRequest(
    () => profileApi.requestCompany(companyId, section, documentType),
    undefined,
    true,
    {
      withoutNotification: false,
      isThrowError: true,
    },
    false
  )

  const onRequest = async () => {
    try {
      await requestCompany()
      dispatch(setPageStatus({ [section]: REGISTRATION_STATUSES.REQUESTED }))
      dispatch(setAccountStatus('Requested'))
      dispatch(
        setNotificationMessage({
          notificationMessage: REQUEST_MODAL_SUCCESS_NOTIFICATION,
          type: 'warning',
        })
      )
      getCompanyInfo(Number(companyId))
      onClose()
    } catch (err) {}
  }

  return (
    <Modal
      onClose={onClose}
      position="center-horizontal"
      title={REQUEST_MODAL_TITLE}
      popupClassName={styles.popup}
      headerSize="large"
      isDelimiter
    >
      <div className={styles.content}>
        <Typography
          name="Button1"
          color="grey500"
          className={styles.description}
        >
          {REQUEST_MODAL_DESCRIPTION}
          <Typography name="Button1" color="grey500">
            {REQUEST_MODAL_SEND_EMAIL}
          </Typography>
        </Typography>
        <div className={styles.actions}>
          <Button
            label={CANCEL}
            variant="secondary-border"
            size="large"
            onClick={onClose}
          />
          <Button
            label={CONFIRM}
            size="large"
            onClick={onRequest}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  )
}
